// info fetch
export const FETCH_SIJILAT_CR_LIST_REQ = 'FETCH_SIJILAT_CR_LIST_REQ';
export const FETCH_SIJILAT_CR_LIST_RES = 'FETCH_SIJILAT_CR_LIST_RES';
export const FETCH_SIJILAT_CR_LIST_ERR = 'FETCH_SIJILAT_CR_LIST_ERR';

// fetch CR details for CPR
// export const FETCH_CPR_SIJILAT_INFO_REQ = 'FETCH_CPR_SIJILAT_INFO_REQ';
// export const FETCH_CPR_SIJILAT_INFO_RES = 'FETCH_CPR_SIJILAT_INFO_RES';
// export const FETCH_CPR_SIJILAT_INFO_ERR = 'FETCH_CPR_SIJILAT_INFO_ERR';